import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { buttonVariants } from '@cold-ambulance/shadcn';
import { SuccessIcon } from '@cold-ambulance/ui';

import { NewRequestButton } from '../../components/new-request-button.tsx';

export default function RequestCreated() {
  const { t } = useTranslation();
  return (
    <div className="page-container">
      <div className="mx-auto flex min-h-0 max-w-xs flex-1 flex-col justify-center">
        <div className="flex flex-col items-center justify-center gap-y-6">
          <SuccessIcon />
          <p className="text-3xl font-semibold">{t('requests.requestSentSuccess')}</p>
        </div>
        <p className="mt-4 text-center">
          {t('requests.requestSentNotification')}{' '}
        </p>
        <Link
          to="/"
          className={buttonVariants({
            variant: 'default',
            className: 'mt-20 !h-11 px-6',
          })}
        >
          {t('requests.goToDashboard')}
        </Link>
        <div className="mb-4"></div>
        <NewRequestButton variant={'outline'} className="bg-transparent text-primary" />
      </div>
    </div>
  );
}
